// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/item_group.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/item_group.proto.
 */
export const file_inventory_v1_item_group: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types]);

/**
 * ItemGroup message definition
 *
 * @generated from message inventory.v1.ItemGroup
 */
export type ItemGroup = Message<"inventory.v1.ItemGroup"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID parent_id = 2;
   */
  parentId?: ID;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string number = 4;
   */
  number: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string notes = 6;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 7;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: string default_pricing_unit = 8;
   */
  defaultPricingUnit: string;

  /**
   * @generated from field: int32 color_hue = 9;
   */
  colorHue: number;

  /**
   * @generated from field: types.Base base = 10;
   */
  base?: Base;
};

/**
 * Describes the message inventory.v1.ItemGroup.
 * Use `create(ItemGroupSchema)` to create a new message.
 */
export const ItemGroupSchema: GenMessage<ItemGroup> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 0);

/**
 * Request/Response messages for ItemGroup queries
 *
 * @generated from message inventory.v1.GetItemGroupRequest
 */
export type GetItemGroupRequest = Message<"inventory.v1.GetItemGroupRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetItemGroupRequest.
 * Use `create(GetItemGroupRequestSchema)` to create a new message.
 */
export const GetItemGroupRequestSchema: GenMessage<GetItemGroupRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 1);

/**
 * @generated from message inventory.v1.GetItemGroupResponse
 */
export type GetItemGroupResponse = Message<"inventory.v1.GetItemGroupResponse"> & {
  /**
   * @generated from field: inventory.v1.ItemGroup item_group = 1;
   */
  itemGroup?: ItemGroup;
};

/**
 * Describes the message inventory.v1.GetItemGroupResponse.
 * Use `create(GetItemGroupResponseSchema)` to create a new message.
 */
export const GetItemGroupResponseSchema: GenMessage<GetItemGroupResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 2);

/**
 * @generated from message inventory.v1.ListItemGroupsRequest
 */
export type ListItemGroupsRequest = Message<"inventory.v1.ListItemGroupsRequest"> & {
  /**
   * @generated from field: inventory.v1.ListItemGroupsFilter filter = 1;
   */
  filter?: ListItemGroupsFilter;

  /**
   * @generated from field: repeated inventory.v1.ItemGroupSortOption sorting = 2;
   */
  sorting: ItemGroupSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message inventory.v1.ListItemGroupsRequest.
 * Use `create(ListItemGroupsRequestSchema)` to create a new message.
 */
export const ListItemGroupsRequestSchema: GenMessage<ListItemGroupsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 3);

/**
 * @generated from message inventory.v1.ListItemGroupsFilter
 */
export type ListItemGroupsFilter = Message<"inventory.v1.ListItemGroupsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue parent_id = 2;
   */
  parentId?: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 3;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 4;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 5;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 6;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue default_pricing_unit = 8;
   */
  defaultPricingUnit?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 10;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 11;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.ListItemGroupsFilter.
 * Use `create(ListItemGroupsFilterSchema)` to create a new message.
 */
export const ListItemGroupsFilterSchema: GenMessage<ListItemGroupsFilter> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 4);

/**
 * @generated from message inventory.v1.ListItemGroupsResponse
 */
export type ListItemGroupsResponse = Message<"inventory.v1.ListItemGroupsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.ItemGroup item_groups = 1;
   */
  itemGroups: ItemGroup[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message inventory.v1.ListItemGroupsResponse.
 * Use `create(ListItemGroupsResponseSchema)` to create a new message.
 */
export const ListItemGroupsResponseSchema: GenMessage<ListItemGroupsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 5);

/**
 * Command messages
 *
 * @generated from message inventory.v1.CreateItemGroupRequest
 */
export type CreateItemGroupRequest = Message<"inventory.v1.CreateItemGroupRequest"> & {
  /**
   * @generated from field: inventory.v1.ItemGroupInput input = 1;
   */
  input?: ItemGroupInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.CreateItemGroupRequest.
 * Use `create(CreateItemGroupRequestSchema)` to create a new message.
 */
export const CreateItemGroupRequestSchema: GenMessage<CreateItemGroupRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 6);

/**
 * @generated from message inventory.v1.CreateItemGroupResponse
 */
export type CreateItemGroupResponse = Message<"inventory.v1.CreateItemGroupResponse"> & {
  /**
   * @generated from field: inventory.v1.ItemGroup item_group = 1;
   */
  itemGroup?: ItemGroup;
};

/**
 * Describes the message inventory.v1.CreateItemGroupResponse.
 * Use `create(CreateItemGroupResponseSchema)` to create a new message.
 */
export const CreateItemGroupResponseSchema: GenMessage<CreateItemGroupResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 7);

/**
 * @generated from message inventory.v1.UpdateItemGroupRequest
 */
export type UpdateItemGroupRequest = Message<"inventory.v1.UpdateItemGroupRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: inventory.v1.ItemGroupUpdateInput input = 2;
   */
  input?: ItemGroupUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.UpdateItemGroupRequest.
 * Use `create(UpdateItemGroupRequestSchema)` to create a new message.
 */
export const UpdateItemGroupRequestSchema: GenMessage<UpdateItemGroupRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 8);

/**
 * @generated from message inventory.v1.UpdateItemGroupResponse
 */
export type UpdateItemGroupResponse = Message<"inventory.v1.UpdateItemGroupResponse"> & {
  /**
   * @generated from field: inventory.v1.ItemGroup item_group = 1;
   */
  itemGroup?: ItemGroup;
};

/**
 * Describes the message inventory.v1.UpdateItemGroupResponse.
 * Use `create(UpdateItemGroupResponseSchema)` to create a new message.
 */
export const UpdateItemGroupResponseSchema: GenMessage<UpdateItemGroupResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 9);

/**
 * @generated from message inventory.v1.DeleteItemGroupRequest
 */
export type DeleteItemGroupRequest = Message<"inventory.v1.DeleteItemGroupRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.DeleteItemGroupRequest.
 * Use `create(DeleteItemGroupRequestSchema)` to create a new message.
 */
export const DeleteItemGroupRequestSchema: GenMessage<DeleteItemGroupRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 10);

/**
 * Input messages
 *
 * @generated from message inventory.v1.ItemGroupInput
 */
export type ItemGroupInput = Message<"inventory.v1.ItemGroupInput"> & {
  /**
   * @generated from field: types.ID parent_id = 1;
   */
  parentId?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string number = 3;
   */
  number: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string notes = 5;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 6;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: string default_pricing_unit = 7;
   */
  defaultPricingUnit: string;

  /**
   * @generated from field: int32 color_hue = 8;
   */
  colorHue: number;
};

/**
 * Describes the message inventory.v1.ItemGroupInput.
 * Use `create(ItemGroupInputSchema)` to create a new message.
 */
export const ItemGroupInputSchema: GenMessage<ItemGroupInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 11);

/**
 * @generated from message inventory.v1.ItemGroupUpdateInput
 */
export type ItemGroupUpdateInput = Message<"inventory.v1.ItemGroupUpdateInput"> & {
  /**
   * @generated from field: types.ID parent_id = 1;
   */
  parentId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 3;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 4;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 5;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 6;
   */
  customAttributes?: string;

  /**
   * @generated from field: google.protobuf.StringValue default_pricing_unit = 7;
   */
  defaultPricingUnit?: string;

  /**
   * @generated from field: google.protobuf.Int32Value color_hue = 8;
   */
  colorHue?: number;
};

/**
 * Describes the message inventory.v1.ItemGroupUpdateInput.
 * Use `create(ItemGroupUpdateInputSchema)` to create a new message.
 */
export const ItemGroupUpdateInputSchema: GenMessage<ItemGroupUpdateInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 12);

/**
 * GetItemGroupsByCustomAttributeRequest - custom query request
 *
 * @generated from message inventory.v1.GetItemGroupsByCustomAttributeRequest
 */
export type GetItemGroupsByCustomAttributeRequest = Message<"inventory.v1.GetItemGroupsByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated string attribute_values = 2;
   */
  attributeValues: string[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetItemGroupsByCustomAttributeRequest.
 * Use `create(GetItemGroupsByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetItemGroupsByCustomAttributeRequestSchema: GenMessage<GetItemGroupsByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 13);

/**
 * GetItemGroupsByCustomAttributeResponse - custom query response
 *
 * @generated from message inventory.v1.GetItemGroupsByCustomAttributeResponse
 */
export type GetItemGroupsByCustomAttributeResponse = Message<"inventory.v1.GetItemGroupsByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.ItemGroup result = 1;
   */
  result: ItemGroup[];
};

/**
 * Describes the message inventory.v1.GetItemGroupsByCustomAttributeResponse.
 * Use `create(GetItemGroupsByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetItemGroupsByCustomAttributeResponseSchema: GenMessage<GetItemGroupsByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group, 14);

/**
 * @generated from enum inventory.v1.ItemGroupSortOption
 */
export enum ItemGroupSortOption {
  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_NAME_ASC = 1;
   */
  NAME_ASC = 1,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_NAME_DESC = 2;
   */
  NAME_DESC = 2,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_NUMBER_ASC = 3;
   */
  NUMBER_ASC = 3,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_NUMBER_DESC = 4;
   */
  NUMBER_DESC = 4,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_CREATED_AT_ASC = 5;
   */
  CREATED_AT_ASC = 5,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_CREATED_AT_DESC = 6;
   */
  CREATED_AT_DESC = 6,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_UPDATED_AT_ASC = 7;
   */
  UPDATED_AT_ASC = 7,

  /**
   * @generated from enum value: ITEM_GROUP_SORT_OPTION_UPDATED_AT_DESC = 8;
   */
  UPDATED_AT_DESC = 8,
}

/**
 * Describes the enum inventory.v1.ItemGroupSortOption.
 */
export const ItemGroupSortOptionSchema: GenEnum<ItemGroupSortOption> = /*@__PURE__*/
  enumDesc(file_inventory_v1_item_group, 0);

/**
 * Services
 *
 * @generated from service inventory.v1.ItemGroupQueriesService
 */
export const ItemGroupQueriesService: GenService<{
  /**
   * @generated from rpc inventory.v1.ItemGroupQueriesService.GetItemGroup
   */
  getItemGroup: {
    methodKind: "unary";
    input: typeof GetItemGroupRequestSchema;
    output: typeof GetItemGroupResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemGroupQueriesService.ListItemGroups
   */
  listItemGroups: {
    methodKind: "unary";
    input: typeof ListItemGroupsRequestSchema;
    output: typeof ListItemGroupsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemGroupQueriesService.GetItemGroupsByCustomAttribute
   */
  getItemGroupsByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetItemGroupsByCustomAttributeRequestSchema;
    output: typeof GetItemGroupsByCustomAttributeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_item_group, 0);

/**
 * @generated from service inventory.v1.ItemGroupCommandsService
 */
export const ItemGroupCommandsService: GenService<{
  /**
   * @generated from rpc inventory.v1.ItemGroupCommandsService.CreateItemGroup
   */
  createItemGroup: {
    methodKind: "unary";
    input: typeof CreateItemGroupRequestSchema;
    output: typeof CreateItemGroupResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemGroupCommandsService.UpdateItemGroup
   */
  updateItemGroup: {
    methodKind: "unary";
    input: typeof UpdateItemGroupRequestSchema;
    output: typeof UpdateItemGroupResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ItemGroupCommandsService.DeleteItemGroup
   */
  deleteItemGroup: {
    methodKind: "unary";
    input: typeof DeleteItemGroupRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_item_group, 1);

